import {ComponentType} from 'react';

type HOC<T, R> = (component: ComponentType<T>) => ComponentType<R>;

function composeHOC<In, IT, Out>(f1: HOC<In, IT>, f2: HOC<IT, Out>): HOC<In, Out>
function composeHOC<In, IT1, IT2, Out>(f1: HOC<In, IT1>, f2: HOC<IT1, IT2>, f3: HOC<IT2, Out>): HOC<In, Out>
function composeHOC<In, IT1, IT2, IT3, Out>(f1: HOC<In, IT1>, f2: HOC<IT1, IT2>, f3: HOC<IT2, IT3>, f4: HOC<IT3, Out>): HOC<In, Out>
function composeHOC<In, IT1, IT2, IT3, IT4, Out>(f1: HOC<In, IT1>, f2: HOC<IT1, IT2>, f3: HOC<IT2, IT3>, f4: HOC<IT3, IT4>, f5: HOC<IT4, Out>): HOC<In, Out>
function composeHOC<In, Out>(...args: HOC<any, any>[]): HOC<In, Out> {
	return function (component) {
		let out: any = component;
		for (let f of args) {
			out = f(out);
		}
		return out;
	};
}

export {composeHOC};
